import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch } from '../../../redux/store/store'
import "./TabBarMyHistory.css"
import React from 'react'
import { changeIndexTabReducerHistory } from '../../../redux/slices/components/MyHistory/myHistoryDataSlice'

type TabOfferOption = { index: number }

const colorsAnimation = ["gray", "blue", "red"]
const typesOffers = ["all", "Job", "Task"]


const TabBarMyHistory = () => {

    const { t } = useTranslation();
    const dispatch = useAppDispatch()

    //const navigate = useNavigate()

    //const [searchParams] = useSearchParams();

    const [leftLine, setLeftLine] = useState<number>(0)

    const marginBetweenOptions = 1; // rem
    const widthOption = 15; // rem

    const indexTab = useSelector((state: RootState) => state.myHistoryData.indexTab);

    useEffect(() => {
        if(indexTab < 0)
            setLeftLine(0)
        else if(indexTab === 2)
            setLeftLine((1) * (widthOption+marginBetweenOptions))
    }, [indexTab])
    

    const setTab = ({ index }: TabOfferOption) => {

        if(index === indexTab)
            return

        const smallLine = document.getElementById("small-line-history") 

        if(smallLine){

            let remsToMove = 0
            if(indexTab > 0)
                remsToMove = ((index - indexTab) * (widthOption+marginBetweenOptions) );
            else
                remsToMove = ((index - 1) * (widthOption+marginBetweenOptions) ); // case after search bar

            smallLine.animate([
                { left: `${leftLine}rem` },
                { left: `${remsToMove + leftLine}rem` }
            ], {
                fill: "forwards",
                duration: 300,
                iterations: 1
            });
            setLeftLine(remsToMove + leftLine)
            dispatch(changeIndexTabReducerHistory({indexTab : index}))
            //navigate(`/manage-offers?limit=${limit}&page=${1}&type=${typesOffers[index] === "Task" ? "Task" : "Job"}`)
            //dispatch(GetOffersThunk({ type: typesOffers[index] === "Task" ? "Task" : "Job", page: 1, limit, bringTotal: true }))
        }
    }

    return (
        <div id="container-tab" className="con-all-options-tab-history">

            <div 
                className={`option-tab-history ${indexTab === 1 ? "" : "pointer"}`}  
                onClick={() => setTab({ index: 1 })}
            >
                <p className={`text-option-tab ${indexTab === 1  ? "italic text-tab-blue" : ""}`}>{t("History:label_02")}</p>
                <div id="1-option" className="option-line"></div>
            </div>
            
            <div 
                className={`option-tab-history ${indexTab === 2 ? "" : "pointer"}`}  
                onClick={() => setTab({ index: 2  })}
            >
                <p className={`text-option-tab ${indexTab === 2  ? "italic text-tab-red" : ""}`}>{t("History:label_03")}</p>
                <div id="2-option" className="option-line"></div>
            </div>

                <div 
                    id="small-line-history" 
                    style={{ left: `${leftLine.toString()}rem`, }} 
                    className={`small-line-history ${colorsAnimation[indexTab]}-line ${indexTab < 0 ? "visibility-hidden" : ""}`}
                ></div>
            
            <div className="whole-line"></div>

        </div>
    )
}

// 33cef213-1c57-47aa-814e-16f1bba7bb70
// ${indexTab < 0 ? "visibility-hidden" : ""}
export default React.memo( TabBarMyHistory )